export default __webpack_public_path__ + "static/media/treeArrow.12a60d42.svg";